"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = exports.routeNames = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const App_1 = __importDefault(require("../App"));
const MainPage_1 = __importDefault(require("../components/MainPage"));
const Test_1 = __importDefault(require("../components/Test"));
const client_1 = __importDefault(require("../components/compliance-pools/client"));
const AdminTools_1 = __importDefault(require("../components/compliance-pools/admin/AdminTools"));
const ShipAdmin_1 = __importDefault(require("../components/compliance-pools/admin/ShipAdmin"));
const ShipsAdmin_1 = __importDefault(require("../components/compliance-pools/admin/ShipsAdmin"));
const ShipsClient_1 = __importDefault(require("../components/compliance-pools/client/ShipsClient"));
const VoyageAdmin_1 = __importDefault(require("../components/compliance-pools/admin/VoyageAdmin"));
const fleet_calculator_1 = __importDefault(require("../components/fleet-calculator"));
const surplus_calculator_1 = __importDefault(require("../components/surplus-calculator"));
const voyage_1 = __importDefault(require("../components/voyage"));
const PoolAdmin_1 = __importDefault(require("../components/compliance-pools/admin/PoolAdmin"));
const FleetAdmin_1 = __importDefault(require("../components/compliance-pools/admin/FleetAdmin"));
const PoolsAdmin_1 = __importDefault(require("../components/compliance-pools/admin/PoolsAdmin"));
const TransactionsAdmin_1 = __importDefault(require("../components/compliance-pools/admin/TransactionsAdmin"));
const CompaniesAdmin_1 = __importDefault(require("../components/compliance-pools/admin/CompaniesAdmin"));
const FleetsAdmin_1 = __importDefault(require("../components/compliance-pools/admin/FleetsAdmin"));
const UsersAdmin_1 = __importDefault(require("../components/compliance-pools/admin/UsersAdmin"));
const ProtectedRoute_1 = require("../components/ProtectedRoute");
const TestDataTools_1 = __importDefault(require("../components/compliance-pools/admin/TestDataTools"));
const IntegrationTools_1 = __importDefault(require("../components/compliance-pools/admin/IntegrationTools"));
const PoolClient_1 = __importDefault(require("../components/compliance-pools/client/PoolClient"));
const ComplianceTools_1 = __importDefault(require("../components/compliance-pools/client/ComplianceTools"));
const ShipClient_1 = __importDefault(require("../components/compliance-pools/client/ShipClient"));
const CompanyAdmin_1 = __importDefault(require("../components/compliance-pools/admin/CompanyAdmin"));
const MonthlyReportAdmin_1 = __importDefault(require("../components/compliance-pools/admin/MonthlyReportAdmin"));
const FleetClient_1 = __importDefault(require("../components/compliance-pools/client/FleetClient"));
const PortsAdmin_1 = __importDefault(require("../components/compliance-pools/admin/PortsAdmin"));
const DocumentAdmin_1 = __importDefault(require("../components/compliance-pools/admin/DocumentAdmin"));
const PoolEOYReport_1 = __importDefault(require("../components/compliance-pools/admin/PoolEOYReport"));
const biofuel_switch_calculator_1 = __importDefault(require("../components/biofuel-switch-calculator"));
const isProduction = process.env.NODE_ENV === "production";
exports.routeNames = {
    main: "/",
    voyage: "/voyage-calculator",
    fleetCalculator: "/fleet-calculator",
    surplusCalculator: "/surplus-calculator",
    biofuelSwitchCalculator: "/biofuel-switch-calculator",
    complianceTools: "/compliance",
    complianceRoot: "/compliance",
    ships: "ships",
    ship: "ship",
    pool: "pool",
    fleet: "fleet",
    companiesAdmin: "companies",
    companyAdmin: "company",
    monthlyReportAdmin: "monthly-report",
    fleetsAdmin: "fleets",
    fleetAdmin: "fleet",
    usersAdmin: "users",
    transactionsAdmin: "transactions",
    login: "/login",
    test: "/test",
    admin: "/compliance/admin",
    testDataTools: "test-data-tools",
    integrationTools: "integration-tools",
    shipsAdmin: "ships",
    shipAdmin: "ship",
    voyageAdmin: "voyage",
    poolsAdmin: "pools",
    poolAdmin: "pool",
    eoyReport: "eoy-report",
    portsAdmin: "ports",
    portAdmin: "ports",
    documentsAdmin: "documents",
};
exports.routes = [
    {
        path: exports.routeNames.main,
        element: (0, jsx_runtime_1.jsx)(App_1.default, {}),
        children: [
            {
                path: exports.routeNames.voyage,
                element: ((0, jsx_runtime_1.jsx)(ProtectedRoute_1.ProtectedRoute, { children: (0, jsx_runtime_1.jsx)(voyage_1.default, {}) })),
            },
            {
                path: exports.routeNames.test,
                element: ((0, jsx_runtime_1.jsx)(ProtectedRoute_1.ProtectedRoute, { needsAdmin: true, children: (0, jsx_runtime_1.jsx)(Test_1.default, {}) })),
            },
            {
                path: exports.routeNames.fleetCalculator,
                element: (0, jsx_runtime_1.jsx)(fleet_calculator_1.default, {}),
            },
            {
                path: exports.routeNames.surplusCalculator,
                element: (0, jsx_runtime_1.jsx)(surplus_calculator_1.default, {}),
            },
            {
                path: exports.routeNames.biofuelSwitchCalculator,
                element: (0, jsx_runtime_1.jsx)(biofuel_switch_calculator_1.default, {}),
            },
            {
                path: exports.routeNames.complianceTools,
                element: ((0, jsx_runtime_1.jsx)(ProtectedRoute_1.ProtectedRoute, { children: (0, jsx_runtime_1.jsx)(ComplianceTools_1.default, {}) })),
                children: [
                    {
                        path: exports.routeNames.complianceRoot,
                        element: (0, jsx_runtime_1.jsx)(client_1.default, {}),
                    },
                    {
                        path: exports.routeNames.ships,
                        element: (0, jsx_runtime_1.jsx)(ShipsClient_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.ship}/:shipId`,
                        element: (0, jsx_runtime_1.jsx)(ShipClient_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.pool}/:poolId`,
                        element: (0, jsx_runtime_1.jsx)(PoolClient_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.fleet}/:fleetId`,
                        element: (0, jsx_runtime_1.jsx)(FleetClient_1.default, {}),
                    },
                ],
            },
            {
                path: exports.routeNames.admin,
                element: ((0, jsx_runtime_1.jsx)(ProtectedRoute_1.ProtectedRoute, { needsAdmin: true, children: (0, jsx_runtime_1.jsx)(AdminTools_1.default, {}) })),
                children: [
                    {
                        path: exports.routeNames.shipsAdmin,
                        element: (0, jsx_runtime_1.jsx)(ShipsAdmin_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.shipAdmin}/:shipId`,
                        element: (0, jsx_runtime_1.jsx)(ShipAdmin_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.voyageAdmin}/:voyageId`,
                        element: (0, jsx_runtime_1.jsx)(VoyageAdmin_1.default, {}),
                    },
                    {
                        path: exports.routeNames.poolsAdmin,
                        element: (0, jsx_runtime_1.jsx)(PoolsAdmin_1.default, {}),
                    },
                    {
                        path: exports.routeNames.documentsAdmin,
                        element: (0, jsx_runtime_1.jsx)(DocumentAdmin_1.default, {}),
                    },
                    {
                        path: exports.routeNames.portsAdmin,
                        element: (0, jsx_runtime_1.jsx)(PortsAdmin_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.poolAdmin}/:poolId`,
                        element: (0, jsx_runtime_1.jsx)(PoolAdmin_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.poolAdmin}/:poolId/${exports.routeNames.eoyReport}`,
                        element: (0, jsx_runtime_1.jsx)(PoolEOYReport_1.default, {}),
                    },
                    {
                        path: exports.routeNames.transactionsAdmin,
                        element: (0, jsx_runtime_1.jsx)(TransactionsAdmin_1.default, {}),
                    },
                    {
                        path: exports.routeNames.companiesAdmin,
                        element: (0, jsx_runtime_1.jsx)(CompaniesAdmin_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.companyAdmin}/:companyId`,
                        element: (0, jsx_runtime_1.jsx)(CompanyAdmin_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.monthlyReportAdmin}/:companyId/pool/:poolId/year/:year/month/:month`,
                        element: (0, jsx_runtime_1.jsx)(MonthlyReportAdmin_1.default, {}),
                    },
                    {
                        path: exports.routeNames.fleetsAdmin,
                        element: (0, jsx_runtime_1.jsx)(FleetsAdmin_1.default, {}),
                    },
                    {
                        path: exports.routeNames.usersAdmin,
                        element: (0, jsx_runtime_1.jsx)(UsersAdmin_1.default, {}),
                    },
                    {
                        path: `${exports.routeNames.fleetAdmin}/:fleetId`,
                        element: (0, jsx_runtime_1.jsx)(FleetAdmin_1.default, {}),
                    },
                    ...(!isProduction
                        ? [
                            {
                                path: exports.routeNames.testDataTools,
                                element: (0, jsx_runtime_1.jsx)(TestDataTools_1.default, {}),
                            },
                        ]
                        : []),
                    {
                        path: exports.routeNames.integrationTools,
                        element: (0, jsx_runtime_1.jsx)(IntegrationTools_1.default, {}),
                    },
                ],
            },
            {
                path: exports.routeNames.main,
                element: (0, jsx_runtime_1.jsx)(MainPage_1.default, {}),
            },
        ],
    },
];
